import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useMemo } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'

const MobileRecordRow = ({ title, mobileRecordRoute, urlParam }) => {
  let [searchParams] = useSearchParams()
  const { noteId } = useParams()

  const currentTabName = useMemo(() => searchParams.get("tab"), [searchParams])

  const isSelected = useMemo(() => (
    (currentTabName && currentTabName === urlParam) || (noteId && parseInt(urlParam) === parseInt(noteId))
  ), [currentTabName, noteId, urlParam])

  return (
    <div className='divide-x divide-gray-200 min-w-32'>
      <div
        className={`bg-gray-50 px-6 py-3 text-left text-sm font-medium uppercase tracking-wider flex flex-row justify-between items-center ${isSelected ? 'bg-gray-100' : 'bg-white'}`}>
        <Link to={mobileRecordRoute} className='flex flex-row gap-x-2 items-center'>
          <FontAwesomeIcon className='cursor-pointer w-8' icon={isSelected ? faChevronDown : faChevronRight} />
          <div className="flex flex-col">
            <p>{title}</p>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default MobileRecordRow
